import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    loadingMiddle: {
      position: 'absolute',
      left: '50%',
      right: '50%',
      top: '50%',
      bottom: '50%',
    },
    internalPositionLayout: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  };
};
